<template id="hotlineBar">
<section class="hotlineBar">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <h6>CS Hotline<span><a href="tel:+85231658845"><img alt="phoneIcon" src="images/phn.png">+852 3165-8845</a></span></h6>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <div class="hotlineIcon">
          <a href="mailto:sales@sampsonstore.com"><img alt="Email" src="images/messageicon.png"></a>
          <a href="https://www.facebook.com/sampsonstore" target="_blank"><img alt="Facebook" src="images/facebookicon.png"></a>
          <a href="https://www.instagram.com/sampsonstore/" target="_blank"><img alt="Instagram" src="images/instaicon.png"></a>
          <a href="https://www.youtube.com/user/SampsonStore" target="_blank"><img alt="Youtube" src="images/youtubeicon.png"></a>
          <!-- <img alt="Message" src="images/chaticon.png"> -->
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'hotlineBar',
  props:['name'],
  data () {
    return {
    }
  },
  mounted: function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HotlineBar.vue